import request from '@/services/base/request';
import ServicesEnum from '@/services/_helpers/_types';
export default {
    plugBuddy: () => request(ServicesEnum.traderProfile, '/buddy/', 'post', null),
    unplugBuddy: (data) => request(ServicesEnum.traderProfile, `/buddy/${data.sessionId}`, 'delete', null),
    getBuddyData: () => request(ServicesEnum.traderProfile, '/buddy/', 'get', null)
};
